import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Providers from '../containers/contacts/Providers';
import Clients from '../containers/contacts/Clients';
import ContactsDash from '../containers/contacts/ContactsDash';
import Error404 from '../containers/Error404';

class ContactsRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path={this.props.match.path} component={ContactsDash}/>
                    <Route exact path={`${this.props.match.path}/clients`} component={Clients}/>
                    <Route exact path={`${this.props.match.path}/providers`} component={Providers}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
            </div>
        );
    }
}

export default ContactsRoute;



// WEBPACK FOOTER //
// ./src/routes/ContactsRoute.js